<script setup lang="ts">
// The Czech blog, /cs/blog: its own posts, not translations of the English ones
// (constants/blog.ts). Czech is its only language.
false && /*#__PURE__*/ defineI18nRoute({ locales: ['cs'], paths: { cs: '/blog' } })

definePageMeta({
  layout: 'blog',
  blogLocale: 'cs',
})

const listing = await useBlogListing({ locale: 'cs' })
</script>

<template>
  <BlogListing
    :posts="listing.posts.value"
    :page="listing.page"
    :page-count="listing.pageCount.value"
    :base-path="listing.basePath"
    :category="listing.category"
    :search-query="listing.searchQuery.value"
    locale="cs"
    @search="listing.submitSearch"
  />
</template>
